import { useState, createContext } from 'react';

const defaultValue = {
  notify: {
    message: 'This',
    isOpen: false,
    type: 'info',
  },
};

export const globalAction = createContext({
  state: defaultValue,
  setState: null,
});

export const GlobalActionProvider = ({ children }) => {
  const [state, setState] = useState(defaultValue);

  return <globalAction.Provider value={{ state, setState }}>{children}</globalAction.Provider>;
};
